import { SegmentEvent } from '/@/integrations/segment/SegmentEvent';
import { BaseInboxEventTracking } from '/@/modules/inbox/models/segmentevents/BaseInboxEventTracking';

export class InboxClickEventTracking extends BaseInboxEventTracking {
  static eventName: string = SegmentEvent.INBOX_CLICK;
}
